<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="dialogVisible = true"
      >添加</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新建项目"
      width="1200px"
      @close="closeDialog"
    >
      <el-form :model="detail" :ref="`form`" :rules="rules" label-width="140px">
        <el-form-item label="题目：" prop="problem" required>
          <el-input
            :placeholder="`${item.label}题目`"
            v-for="item in languageList"
            :key="item.value + 'p'"
            v-model="detail.problem[item.value]"
          ></el-input>
        </el-form-item>
        <el-form-item label="题目需要详细介绍">
          <el-checkbox v-model="needDescription"></el-checkbox>
        </el-form-item>
        <el-form-item
          v-if="needDescription"
          :label="`题目介绍（${lang.label}）：`"
          v-for="lang in languageList"
          :key="lang.value"
        >
          <editor
            v-model="detail.description[lang.value]"
            class="editor"
          ></editor>
        </el-form-item>
        <el-form-item label="答案" prop="answer" required>
          <answer-input v-model="detail.answer" />
        </el-form-item>
        <el-form-item label="起止时间：" required>
          <el-col :span="7">
            <el-form-item prop="startTime">
              <el-date-picker
                v-model="detail.startTime"
                value-format="timestamp"
                type="datetime"
                placeholder="选择开始时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item prop="endTime">
              <el-date-picker
                v-model="detail.endTime"
                value-format="timestamp"
                type="datetime"
                placeholder="选择截止时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import LANGUAGE from 'common/languages';
import AnswerInput from '../answerInput';
import Editor from 'components/editor';

export default {
  name: 'votingStrategyCreate',
  data() {
    const validateEndTime = (rule, value, callback) => {
      if (!this.detail.endTime) {
        callback(new Error('请填写'));
      }
      if (
        this.detail.startTime &&
        this.detail.endTime &&
        value < this.detail.startTime
      )
        callback(new Error('截止时间不得早于开始时间'));
      callback();
    };
    const validateStartTime = (rule, value, callback) => {
      if (!this.detail.startTime) {
        callback(new Error('请填写'));
      }
      if (this.detail.startTime < new Date())
        callback(new Error('开始时间不得早于当前时间'));
      callback();
    };
    const validateLanguage = (rule, value, callback) => {
      if (!(this.detail.problem && this.detail.problem[1])) {
        callback(new Error('至少填写中文'));
      }
      callback();
    };
    const validateAnswer = (rule, value, callback) => {
      if (!(this.detail.answer && this.detail.answer.length >= 2)) {
        callback(new Error('至少需要两个选项'));
      } else {
        this.detail.answer.forEach(item => {
          const hasEmpty = this.languageList.find(
            lang => !(item[lang.value] && item[lang.value].trim() !== '')
          );
          if (hasEmpty) {
            callback(new Error('选项中的所有语言，未翻译可都填写为中文'));
          }
        });
      }
      callback();
    };

    return {
      dialogVisible: false,
      needDescription: false,
      detail: {
        problem: {},
        answer: [{}, {}],
        description: {}
      },
      currentLang: '1',
      rules: {
        problem: {
          validator: validateLanguage
        },
        answer: {
          validator: validateAnswer
        },
        startTime: [
          {
            validator: validateStartTime,
            trigger: 'change'
          }
        ],
        endTime: [
          {
            validator: validateEndTime,
            trigger: 'change'
          }
        ]
      }
    };
  },
  components: {
    AnswerInput,
    Editor
  },
  computed: {
    ...mapState('votingStrategy', ['languageList']),
    submitDetil() {
      return {
        ...this.detail,
        problem: JSON.stringify(
          Object.keys(this.detail.problem)
            .map(key => {
              return (
                this.detail.problem[key] && {
                  content: this.detail.problem[key],
                  language: key
                }
              );
            })
            .filter(item => item)
        ),
        description: this.needDescription
          ? JSON.stringify(
              Object.keys(this.detail.description)
                .map(key => {
                  return (
                    this.detail.description[key] && {
                      content: this.detail.description[key],
                      language: key
                    }
                  );
                })
                .filter(item => item)
            )
          : null,
        answer: JSON.stringify(
          this.detail.answer
            .reduce((arr, item, index) => {
              Object.keys(item).forEach(key => {
                const matchedIndex = arr.findIndex(
                  item => item && item.language === key
                );
                if (matchedIndex === -1) {
                  arr.push({
                    language: key,
                    content: {
                      [index + 1]: item[key]
                    }
                  });
                } else {
                  arr[matchedIndex].content[index + 1] = item[key];
                }
              });
              return arr;
            }, [])
            .map(item => {
              return {
                ...item,
                content: JSON.stringify(item.content)
              };
            })
        )
      };
    }
  },
  methods: {
    ...mapActions('votingStrategy', ['create']),
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {
        problem: {},
        answer: [{}, {}],
        description: {}
      };
      this.needDescription = false;
      this.$refs['form'].resetFields();
    },
    handleSave() {
      let errorsInLang = [];
      const that = this;
      that.$refs['form'].validate(valid => {
        if (!valid) return;
        this.doSave();
      });
    },
    doSave() {
      this.create(this.submitDetil).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 100px;
}
</style>
